import { Directive, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';

/**
 * Diretiva para aplicar tema claro somente aos tooltips de ngx-charts
 * onde explicitamente utilizada. Como o tooltip é anexado ao <body>,
 * usamos MutationObserver para detectar sua criação e anexar uma classe
 * de marcação.
 */
@Directive({
  selector: '[whiteTooltip]'
})
export class WhiteTooltipDirective implements OnInit, OnDestroy {
  private observer?: MutationObserver;
  @Input() whiteTooltipModes?: string[];

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    this.observer = new MutationObserver(mutations => this.handleMutations(mutations));
    this.observer.observe(document.body, { childList: true, subtree: true });
  }

  private handleMutations(mutations: MutationRecord[]): void {
    for (const mutation of mutations) {
      this.processAddedNodes(mutation.addedNodes);
    }
  }

  private processAddedNodes(nodes: NodeList): void {
    for (const node of Array.from(nodes)) {
      if (node instanceof HTMLElement && node.classList.contains('ngx-charts-tooltip-content')) {
        this.handleTooltipNode(node);
      }
    }
  }

  private handleTooltipNode(node: HTMLElement): void {
    const innerMarker = node.querySelector('[data-tooltip-mode]') as HTMLElement | null;
    const mode = innerMarker?.getAttribute('data-tooltip-mode');
    if (!this.whiteTooltipModes || (mode && this.whiteTooltipModes.includes(mode))) {
      this.renderer.addClass(node, 'tooltip-light');
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
